module.exports = __webpack_public_path__ + "static/media/background_login_cropped.9fa5eff8.jpg";